






























import { Vue, Component } from 'vue-property-decorator'
import { ExStore } from 'vuex'

@Component
export default class OnlineStatusInput extends Vue {
  $store!: ExStore
  pending = false

  get isOnline() {
    return this.$store.getters['appSettings/isOnline']
  }

  get value() {
    return this.isOnline === undefined ? true : this.isOnline
  }

  set value(value) {
    if (this.isOnline !== value) {
      this.$store.dispatch('appSettings/update', { isOnline: value })
    }
  }

  async handleCangeValue(isOnline: boolean) {
    if (this.pending) {
      return
    }
    try {
      this.pending = true
      await this.$store.dispatch('appSettings/update', { isOnline })
    } catch (error) {
      console.error(error)
    } finally {
      this.pending = false
    }
  }
}
